module.exports = __webpack_public_path__ + "img/loadingpic.df2298f7.gif";